export const extractFaqItems = (slices: any[] = []) => {
  return slices
    .filter((slice) => slice._type === "ottomotors.faq")
    .flatMap((slice) => slice.items || []);
};
